module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/maja-okulus-de985322e554bb0daef7535f6f5f265d.png";